import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"liquid-child {{@class}}\" data-liquid-child={{@uniqueChildId}}\n   ...attributes\n  {{this.setup}}\n>\n  {{~yield~}}\n</div>")